"use client"
import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { PhotoLibraryProps, RenderConfig } from "./RenderConfig"

export const PhotoLibrary: ComponentConfig<PhotoLibraryProps> = {
  label: "Photo Library",
  fields: {
    items: {
      label: "List items",
      type: "array",
      getItemSummary: (Items, index = 0) => `Items: ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        url: {
          label: "Link",
          type: "text",
        },
      },
    },
  },
  defaultProps: {
    items: [
      {
        id: 1,
        url: "/",
        title: "Title",
      },
      {
        id: 2,
        url: "/",
        title: "Title",
      },
      {
        id: 3,
        url: "/",
        title: "Title",
      },
      {
        id: 4,
        url: "/",
        title: "Title",
      },
      {
        id: 5,
        url: "/",
        title: "Title",
      },
      {
        id: 6,
        url: "/",
        title: "Title",
      },
      {
        id: 7,
        url: "/",
        title: "Title",
      },
      {
        id: 8,
        url: "/",
        title: "Title",
      },
      {
        id: 9,
        url: "/",
        title: "Title",
      },
    ],
    height: 500,
  },
  ...RenderConfig,
}
